// extracted by mini-css-extract-plugin
export default {"SearchFormClass":"SearchForm_SearchFormClass__YPpYB"};